import classNames from 'classnames';
import { QuoteFormErrorMessage } from 'routes/essential-workspace/components/quote-panel/quote/form-error-message';
import { PriceQuoteAction } from 'routes/essential-workspace/components/quote-panel/quote/quote-actions/price';
import { QuoteStatus } from 'routes/essential-workspace/components/quote-status';

export function QuoteNotReadySummary({ className, formId }: { className?: string; formId: string }) {
  return (
    <div className={classNames('flex-x text-start gap-3 w-100 justify-content-between', className)}>
      <div className="flex-x gap-2 min-w-0 flex-shrink-1 overflow-hidden">
        <QuoteStatus variant="icon" formId={formId} />
        <div className="text-truncate fw-medium">
          <QuoteFormErrorMessage />
        </div>
      </div>

      <PriceQuoteAction
        size="lg"
        purpose="outline"
        labelTranslationKey="sidePanel.actions.price"
        className="flex-shrink-0"
      />
    </div>
  );
}
